export interface ICouponModel {
  id: string;
  offerId: string;
  referenceId?: string;
  name: string;
  price: number;
  image: string;
  description: string;
  expiryDate: string;
  refineEndDate: string;
  offerComplete: boolean;
  brand: string;
  category: string;
  offerPrice: string;
  status: string;
  offerType: string;
  refineBrand: string;
  refineDescription: string;
  refineOfferPrice: string;
  regularPrice: string;
  usageTypeTxt: string;
  usageType: string;
  offerPgmLabel: string;
  imageId: string;
  couponID: string;
  summary?: string;
  events?: string[];
}

export class CouponModel implements ICouponModel {
  [key: string]: any;
  public id!: string;
  public offerId!: string;
  public referenceId?: string;
  public name!: string;
  public price!: number;
  public image!: string;
  public description!: string;
  public expiryDate!: string;
  public updBtnText: string = 'Added';
  public updBtnMode: Boolean = true;
  public brand!: string;
  public category!: string;
  public offerPrice: string = '';
  public status!: string;
  public deleted!: boolean;
  public offerType!: string;
  public offerTs!: string;
  public endDate!: string;
  public offerPgm!: string;
  public refineBrand!: string;
  public refineDescription!: string;
  public refineOfferPrice!: string;
  public refineEndDate!: string;
  public offerComplete!: boolean;
  public regularPrice!: string;
  public usageTypeTxt!: string;
  public usageType!: string;
  public offerPgmLabel!: string;
  public imageId!: string;
  public couponID!: string;
  public summary?: string;
  public priceTitle?: string;
  public events?: string[];
  public logoSVGCouponCarouseImageEnable?: boolean = false;
  public logoSVGCouponCarouseImage?: string = '';
  
  public itemType?: any;
  public quantity!: string;
  public detailPath!: string;
  public savings!: string;
  public categoryId: any;
  public iconImage!: string;
  public offerProtoType!: string;
  public startDate!: string;
  public usage: any;
  public longTitle!: string;
  public title!: string;
  public imageUrl!: string;


  constructor(data?: any) {
      Object.assign(this, data);
  }
}
export interface IProductModel {
  id: string;
  itemId: string;
  upc: string;
  name: string;
  price: number;
  quantity: number;
  qty: number;
  quantityOrder: number;
  image: string;
  unitOfMeasure: string;
  unitQuantity: string;
  pricePer: number;
  promoDescription: string;
  description: string;
  salesRank: number;
  aisleId: string;
  departmentName: string;
  aisleName: string;
  shelfName: string;
  showStrikeThrough: Boolean;
  offerText: string;
  promoDescriptionVal: string;
  offerComplete: boolean;
  isBOGO: boolean;
  comment: string;
  comments: string;
  substitutionValue: string;
  substitutionPreference: string;
  promoType: string;
  promoTitle: string;
  basePrice: number;
  restrictedValue: number;
  maxPurchaseQty: number;
  previousPurchaseQty: number;
  promoEndDate: string;
  promoText: string;
  inventoryAvailable: string;
  channelEligibility: object;
}
export class ProductModel implements IProductModel {
  [key: string]: any
  public id!: string;
  itemId!: string;
  public upc!: string;
  public name!: string;
  public price!: number;
  public quantity!: number;
  public qty!: number;
  public quantityOrder!: number;
  public image!: string;
  public unitOfMeasure!: string;
  public unitQuantity!: string;
  public pricePer!: number;
  public promoDescription!: string;
  public description!: string;
  public salesRank!: number;
  public aisleId!: string;
  public departmentName!: string;
  public aisleName!: string;
  public shelfName!: string;
  public updBtnText: string = 'Update';
  public updBtnMode: Boolean = true;
  public showStrikeThrough!: Boolean;
  public offerText!: string;
  public promoDescriptionVal!: string;
  public offerComplete!: boolean;
  public isBOGO!: boolean;
  public comment!: string;
  public comments!: string;
  public substitutionValue!: string;
  public substitutionPreference!: string;
  public promoType!: string;
  public promoTitle!: string;
  public basePrice!: number;
  public restrictedValue!: number;
  public maxPurchaseQty!: number;
  public previousPurchaseQty!: number;
  public promoEndDate!: string;
  public promoText!: string;
  public inventoryAvailable!: string;
  public channelEligibility!: object;

  constructor(data?: any) {
      Object.assign(this, data);
  }
}

export interface IProductUpdateModel {
  id: string;
  price: number;
  comment: string;
  substitutionValue: string;
  quantity: number;
}

export interface ISortRule {
  field: string;
  direction: number;
  type: string;
  callback?: (a: ProductModel | CouponModel, s: SortModel) => void;
}

export interface ISort {
  field: string;
  rule: ISortRule[] | null;
  label: any;
  selected?: Boolean | null;
  sort_at: string;
}

export class SortModel implements ISort {
  public field!: string;
  public label: any;
  public rule!: ISortRule[] | null;
  public selected?: Boolean | null;
  public sort_at!: string;

  constructor(data?: any) {
      Object.assign(this, data);
  }
}
export interface SponsoredCarouselModel {
  products: any[];
  offers: any;
}